import React, { ChangeEvent, FormEvent, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IChartList, IGroup, IPlayList, ITitle, ITitleLong } from "../interfaces/Music";
import {
  changeCurrentList,
  publicateTracklist,
  setTrackFlag,
  setSubTitle,
  setCurrentFlag,
  setMessage,
  clearPlayList,
  setCurrentPlayListName,
  setMediaGroups,
 } from "../stores/AppReducer";
import { addMediaTrack,
  delMediaGroup,
  delMediaTrack,
  getChartLists,
  getMediaGroups,
  getMediaTitlelsLong,
  getMediaTitles,
  getPlayListDB,
  getPlayLists,
  postMediaGroup,
  putMediaGroup,
  putPlayListDB,
  updateMediaTrack
} from "../services/apiService";
import Button from "./Button";
import { IApplicationState } from "../stores/AppStore";
import AppSetup from "../core/AppSetup";
import Confirm from "./Confirm";
import CustomSelectBox from "./CustomSelectBox";
import Tabbing from "./Tabbing";
import type { AppDispatch } from "../stores/AppStore";
import { IAppState, MessageType } from "../interfaces/App";

export enum SearchStates {
  none,
  text,
  title,
  group,
  charts,
};
function MediaDatabase() {
  const emptyTrack = {
    id: null as string,
    title: "",
    audioSrc: null as string,
    time: 0,
    group: "",
    grpOnly: false,
  };
  const dispatch = useDispatch<AppDispatch>();
  const app: IAppState = useSelector((appState: IApplicationState) => appState.app);
  const [searchMode, setSearchMode] = useState(SearchStates.none);
  const [state, setState] = useState({text: "", name: "", listId: "0", changed: false, groups: null, selectedGroup: 0});
  const [showGroup, setShowGroup] = useState(false);
  const [found, setFound] = useState(false);
  const [showTrack, setShowTrack] = useState(null as ITitle | ITitleLong);
 // const audioRef = useRef(null);
  const [confirm, setConfirm] = useState(false);
  const [changePlayListName, setChangePlayListName] = useState(false);
  // const audioRef = useRef(new Audio());
  const times = useRef(0);
  useEffect(() => {
    if (times.current++ === 0) {
      dispatch(getPlayLists(undefined));
      dispatch(setSubTitle("Media"));
      dispatch(getChartLists(undefined));
    }
  }, []);
  useEffect(() => {
    if (showTrack && !app.groups) {
      dispatch(getMediaGroups({pattern: "%"}));
    }
  }, [showTrack]);
  useEffect(() => {
    if (searchMode !== SearchStates.none) {
      setShowTrack(null);
    }
  }, [searchMode]);
  
  const getTrackInfo = (track: ITitle) => {
    dispatch(getMediaTitlelsLong(track.id)).then((res: any) => {
      if (res.type === "get/mediaTitelsLong/fulfilled" && res.payload.data.length) {
        setShowTrack({
          id: res.payload.data[0].id,
          time: res.payload.data[0].duration,
          audioSrc: AppSetup.getUserApiUrl() + res.payload.data[0].audioSrc,
          chartPlaces: res.payload.data[0]?.chart_place?.split(","),
          places: res.payload.data[0].​​​​places,
          playlistNames: res.payload.data[0]?.​​​​playlist?.split(","),
          playlists: res.payload.data[0].​​​​playlists,
          title: res.payload.data[0].​​​​title,
          group: res.payload.data[0].group_name,
          changed: false,
          grpOnly: false,
        });
        findGroupIndex(res.payload.data[0].group_name);
      }
    });
    getTracksByGroupFirstLetter("");
  };
  const savePlaylist = () => {
    setState({...state, changed: false});
    const list: string[] = app.currentList.map((t: ITitle) => t.id);
    dispatch(putPlayListDB({id: state.listId, list, name: state.name}));
  };
  const handleSaveList = () => {
    if (state.name !== "noname") {
      savePlaylist()
    } else {
      setConfirm(true);
    }
  };
  const handleDeleteList = () => {
    console.log(state.listId);
  };
  const publicatePlayList = (list: ITitle[]) => {
    let playList: ITitle[];
    if (showTrack?.audioSrc) {
      playList = [{
        id: showTrack.id,
        title: showTrack.title,
        audioSrc: showTrack.audioSrc,
        time: showTrack.time
      }];
    } else {
      const flagged = list.findIndex((e: ITitle) => e.flagged) > -1;
      playList = list.filter((e: ITitle) => flagged ? e.audioSrc && e.flagged : e.audioSrc)
    }
    dispatch(publicateTracklist(playList));
  };
  const getTracksByText = () => {
    dispatch(getMediaTitles({pattern: "%" + state.text + "%", field: "titleGroup"})).then(() => {
        setFound(true);
        setShowTrack(null);
    });
  };
  const getTracksByChartList = (chartId: string) => {
    dispatch(getMediaTitles({pattern: chartId, field: "chartId"})).then(() => setFound(true));
  };
  const getTracksByPlayList = (id: number) => {
    const listId = app.playLists[id].id;
    setState({...state, name: app.playLists[id].name, listId});
    if (parseInt(listId, 10) > 0) {
      dispatch(getPlayListDB(listId)).then(() => {setFound(false); setShowTrack(null)});
    } else {
      dispatch(clearPlayList());
    }
  };
  const getTracksByTitleFirstLetter = (letter: string) => {
    dispatch(getMediaTitles({pattern: letter + "%", field: "title"})).then(() => setFound(true));
  };  
  const getTracksByGroupFirstLetter = (groups: string) => {
    if (groups !== state.groups) {
      setState({...state, groups});
      dispatch(getMediaGroups({pattern: groups + "%"}));
    }
  };
  const getTracksByGroupId = (groupId: string) => {
    dispatch(getMediaTitles({pattern: groupId, field: "groupId"})).then(() => setFound(true));
  };
  const changePlayList = (title: ITitle, what: "add" | "del") => {
    dispatch(changeCurrentList({title, what}));
    setState({...state, changed: true});
  };
  const toggleFlagged = (idx: number, flag: boolean) => {
    dispatch(found ? setTrackFlag({idx, flag: !flag}) : setCurrentFlag({idx, flag: !flag}));
  };
  const findGroupIndex = (grpVal: string): number => {
    const re = new RegExp(grpVal, "i");
    const i = app.groups.findIndex((g: IGroup) => g.name.search(re) > -1);
    if (i > -1) {
      setState({...state, selectedGroup: i});
    }
    return i;
  };
  const newTrack = () => {
    getTracksByGroupFirstLetter("");
    setShowTrack(emptyTrack);
  };
  const updTrack = () => {
    dispatch(updateMediaTrack(showTrack as ITitle)).then((res: any) => {
      if (res.type === "post/updateMediaTrack/fulfilled") {
        setShowTrack({...showTrack, changed: false});
      }
    });
  };
  const addTrack = () => {
    if (!showTrack.title.length) {
      dispatch(setMessage({msg: "Gib einen Titel ein", type: MessageType.hint}));
      return;
    }  
    if (!(showTrack as ITitleLong).group) {
      dispatch(setMessage({msg: "Gib eine Gruppe ein", type: MessageType.hint}));
      return;
    }
    if (!(showTrack as ITitleLong).file) {
      dispatch(setMessage({msg: "Wähle eine Autiodatei", type: MessageType.hint}));
      return;
    }
    dispatch(addMediaTrack(showTrack as ITitleLong)).then((res: any) => {
      if (res.type === "post/addMediaTrack/fulfilled") {
        setShowTrack({
          ...showTrack,
          id: res.payload.data.title_id,
          groupId: res.payload.data.group_id,
          audioSrc: AppSetup.getUserApiUrl() + res.payload.data.audioSrc,
          file: null,
        });
      }
    });
  };
  const saveGroupChanges = () => {
    if (Number(showTrack.groupId) > 0) {
      dispatch(putMediaGroup({group: (showTrack as ITitleLong).group, groupId: showTrack.groupId})); 
    } else {
      dispatch(postMediaGroup((showTrack as ITitleLong).group)).then((res: any) => {
        if (res.type === "post/postMediaGroup/fulfilled") {
          setShowTrack({...showTrack, groupId: res.payload.data.group_id});
          dispatch(getMediaGroups({pattern: "%"}));
        }
      }); 
    }
  };
  const saveTitleChanges = () => {
      showTrack.id ? updTrack() : addTrack()
  };
  const setAudioSource = (file: File) => {
    // https://stackoverflow.com/questions/38265242/play-audio-local-file-with-html
    // console.log("file", file);
    // audioRef.current = new Audio(file.name);
    // console.log(audioRef.current.duration);
    // audioRef.current.play();
    setShowTrack({...showTrack, file, time: 1, changed: true}); // audioRef.current.duration});
  };
  const delTrack = (titleId: string) => {
    dispatch(delMediaTrack(titleId)).then((res: any) => {
        if (res.type === "delete/delMediaTrack/fulfilled") {
          setShowTrack(null);
        }
      });
  };
  const delGroup = (groupId: string) => {
    dispatch(delMediaGroup(groupId)).then((res: any) => {
        if (res.type === "delete/delMediaTrack/fulfilled") {
          setShowTrack(null);
        }
      });
  };
  // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  const renderListItem = (list: IPlayList, idx: number) => {
    return (
      <option key={"list_" + idx} className={(state.changed && list.id === state.listId) ? "play_list_changed" : ""}>
        {list.name}
      </option>
    );
  };
  const renderPlaylists = () => {
    return app.playLists ? (
      <select
        onChange={(ev: any) => {getTracksByPlayList(ev.target.selectedIndex)}}
        disabled={state.changed}
        className={"md_playlist"}
      >
        {app.playLists?.map(renderListItem)}
      </select>
    ) : (null);
  };
  const renderTextSearch = () => {
    return (
      <div > 
        <form className="text_search" name="textsearch" onSubmit={(e: FormEvent<HTMLFormElement>) => {e.preventDefault(); getTracksByText(); return false}}>
          <input 
            // onBlur={() => getTracksByText(state.text)}
            onChange={(ev: ChangeEvent<HTMLInputElement>) => setState({...state, text: ev.target.value})}
            value={state.text}
          />
          <input type="submit" value="Ok" />
        </form>
      </div>
    );
  };
  const renderAlphaIndex = (handler: (c: string) => void) => {
    return (
      <div className="alpha_index">
        {"ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("").map((c: string, n: number) => {
            return (<span key={"c_" + n} onClick={() => handler(c)}>{c}</span>);
          })
        }
      </div>
    );
  };
  const renderChartItem = (list: IChartList, idx: number) =>  {
    return (
      <option 
        className="chart_item"
        key={"chart_" + idx}
        onClick={() => getTracksByChartList(list.id)}
      >
        {list.name}
      </option>
    );
  };
  const renderChartIndex = () => {
    return (
      <select>
        {app.chartLists.map(renderChartItem)}
      </select>
    );
  };
  const renderTrackSearch = () => {
    switch (searchMode) {
      case SearchStates.text: return renderTextSearch();
      case SearchStates.title: return renderAlphaIndex((letter: string) => getTracksByTitleFirstLetter(letter));
      case SearchStates.group: return renderAlphaIndex((letter: string) => getTracksByGroupFirstLetter(letter));
      case SearchStates.charts: return renderChartIndex();
      default: return (<div/>); 
    }
  };
  const renderListFunctions = (track: ITitle, idx: number) => {
    return found 
      ? (
        <div className="right">
          <Button key={"edt_" + idx} label="&#128393;" onClick={() => getTrackInfo(track)} />
          <Button key={"add_" + idx} label="+" onClick={() => changePlayList(track, 'add')} />
        </div>
      ) : (
        <div className="right">
          <Button key={"edt_" + idx} label="+" onClick={() => getTrackInfo(track)} />
          <Button key={"del_" + idx} label="-" onClick={() => changePlayList(track, 'del')} />
        </div>
      );
  };
  const renderTrackList = (track: ITitle, idx: number) => {
    const active = !!track.audioSrc;
    const className = active ? track.flagged ? "track_flagged" : "" : "track_inactive";
    return (
      <div
        key={"track_" + idx}
        className={className}
        onClick={() => toggleFlagged(idx, track.flagged)}
      >
        {track.title}
        {active && renderListFunctions(track, idx)}
        <div className="clear"/>
      </div>
    );
  };
  const renderGroups = (group: IGroup, idx: number) => {
    return (
      <div key={"group_" + idx} onClick={() => getTracksByGroupId(group.id)}>
        {group.name}({group.cnt})
      </div>
    );
  };
  const renderTrackSwitch = () => {
    return (
      <div>
        <div onClick={() => setFound(true)} className={`found_list ${found ? "active" : "inactive"}`} >
            <label>gefunden</label>
        </div>
        <div
            onClick={(ev: any) => ev.detail === 2 ? setChangePlayListName(true) : setFound(false)}
            className={`play_list ${!found ? "active" : "inactive"}`}
          >
          {changePlayListName
          ? <input
              value={state.name}
              onChange={(ev: any) => setState({...state, name: ev.target.value, changed: true})} 
              onBlur={() => {setChangePlayListName(false); dispatch(setCurrentPlayListName({name: state.name, id: state.listId}))}}
              className={`track_title ${!found ? "active" : "inactive"}`}
            />
          : <div>
              <label>Listen</label>
              {renderPlaylists()}
              <Button
                label="&#128190;"
                className={`playlist ${state.changed ? "active" : "inactive"}`}
                disabled={!state.changed}
                onClick={() => {setSearchMode(SearchStates.none); handleSaveList(); }}
                title={"List speichern"}
              />
              <Button
                label="del" // &#128465;
                className={`playlist ${state.listId !== "0" ? "active" : "inactive"}`}
                disabled={state.listId !== "0"}
                onClick={handleDeleteList}
                title={"Liste löschen"}
              />
            </div>}
          </div>
      </div>
    );
  };
  const renderTrackBox = () => {
    return (
      <>
        {renderTrackSwitch()}
        <div className="track_list">
          {found ? app.tracks.map(renderTrackList) : app.currentList.map(renderTrackList)}
          {showGroup && app.groups.map(renderGroups)}
        </div>
      </>
    )
  };
  const renderTrackEdit = (currTrack: ITitleLong) => {
    return (
      <>
        <label htmlFor="title_input" >Titel</label>
        <input
          id={"title_input"}
          value={showTrack.title}
          onChange={(ev: any) => setShowTrack({...currTrack, title: ev.target.value, changed: true})}
        />
        <CustomSelectBox
          label={"Group"}
          list={[...app.groups.map((e: IGroup) => {return {name: e.name, value: e.id}})]}
          rows={0}
          className="custom_select_box"
          value={{name: (showTrack as ITitleLong).group, value: showTrack.groupId}}
          onChange={(group: string) => {
              // console.log("renderTrackEdit:", group);
              const grp = app.groups.find((g: IGroup) => g.name === group);
              setShowTrack({...currTrack, group, groupId: grp ? grp.id : "0"})
            }}
        />
        {currTrack.audioSrc}:{currTrack.groupId}
        <input
          type="file"
          accept="audio/mp3"
          onChange={(ev: any) => setAudioSource(ev.target.files[0])}
          readOnly={currTrack.grpOnly}
          disabled={currTrack.grpOnly}
        />
      </>
    );
  };
  const renderGroupEdit = (currTrack: ITitleLong) => {
    return (
      <CustomSelectBox
        label={"Group"}
        list={[...app.groups.map((e: IGroup) => {return {name: e.name, value: e.id}})]}
        rows={0}
        className="custom_select_box"
        value={{name: (currTrack as ITitleLong).group, value: currTrack.groupId}}
        onChange={(group: string) => {
           // console.log("renderGroupEdit:", group);
          const grp = app.groups.find((g: IGroup) => g.name === group);
          setShowTrack({...currTrack, group, groupId: grp ? grp.id : currTrack.groupId, changed: true});
        }}
        addItem={(group: string) => {
          const nl = [...app.groups];
          nl.push({name: group, id: "0", cnt: 0});
          dispatch(setMediaGroups(nl));
          setShowTrack({...currTrack, group, groupId: "0", changed: true});
        }}
      />
    );
  };
  const renderTitle = (currTrack: ITitleLong) => {
    return currTrack.grpOnly ?
    (
      <h3>
        {currTrack.group ? currTrack.group : "<gruppe>"}
      </h3>
    ) : (
      <h3>
        {currTrack.title ? currTrack.title : "<titel>"}
        {` - `}
        {currTrack.group ? currTrack.group : "<gruppe>"}
        {` : `}
        {currTrack.time}
      </h3>
    );
  };
  const renderTrackInfo = (currTrack: ITitleLong) => {
    return (
      <div className="track_info_box">
        <h4>In Chart</h4>
        <div>{currTrack.chartPlaces?.map((c, i) => (<div key={"chart_" + i}>{c}</div>))}</div>
        <h4>In Playlist</h4>
        <div>{currTrack.playlistNames?.map((l, i) => (<div key={"list_" + i}>{l}</div>))}</div>
      </div>
    );
  };
  const renderTrackGroupEdit = (currTrack: ITitleLong) => {
    // Dusty Springfield - Wishin' And Hopin'
    return (
      <>
        {renderTitle(currTrack)}
        <div className="track_edit">
          <form onSubmit={(ev: any) => {ev.preventDefault(); return false}}>
            <Tabbing
              labels={["Titel", "Gruppe"]}
              onChange={(idx: number) => setShowTrack({...showTrack, grpOnly: idx !== 0})}
            />
            <div className="track_data">
              <div className="track_data_input" >
                {(showTrack as ITitleLong).grpOnly ? renderGroupEdit(currTrack) : renderTrackEdit(currTrack)}
              </div>
              <div className="track_data_input" >
                
                {(showTrack as ITitleLong).grpOnly ? <> 
                    <Button
                      label="&#128190;"
                      onClick={() => saveGroupChanges()}
                      className={"left"}
                      disabled={!showTrack.changed}
                    />
                    <Button
                      label="&#128465;"
                      onClick={() => delGroup(showTrack.groupId)}
                      className={"right"}
                      disabled={!showTrack.groupId}
                    />
                  </> : <>
                    <Button
                      label="&#128190;"
                      onClick={() => saveTitleChanges()}
                      className={"left"}
                      disabled={!showTrack.changed}
                    />
                    <Button
                      label="&#128465;"
                      onClick={() => delTrack(showTrack.id)}
                      className={"right"}
                      disabled={!showTrack.id}
                    />
                  </>}
                  <div className="clear"/>
              </div>
            </div>
          </form>
          <div className="track_info">
              <div className="info_head">
                <h3>Info</h3>
                <Button label="X" onClick={() => setShowTrack(null)} />
                <div className="clear"/>
              </div>
              {!(showTrack as ITitleLong).grpOnly && renderTrackInfo(currTrack)}
          </div>
        </div>
      </>
    );
  };
  const renderListName = () => {
    return (
      <Confirm>
        <form onSubmit={(ev: any) => {ev.preventDefault(); setConfirm(false); savePlaylist(); return false}}>
          <input value={state.name} onChange={(ev: any) => setState({...state, name: ev.target.value})} />
          <input type="submit" value="Ok" />
          <button onClick={() => setConfirm(false)}>Cancel</button>
        </form>
      </Confirm>
    );
  };
  // console.log("check:", {src: showTrack?.audioSrc, tracks: app.tracks?.length } );

  return (
    <div className="page">
        <div className={"mediaDatabase"}>
          {/* first line */}
          {/* {renderPlaylists()} */}
          <Button
            label="&#128270; Volltextsuche"
            className={`md_text ${searchMode === SearchStates.text ? "active" : "inactive"}`}
            onClick={() => setSearchMode(SearchStates.text)}
            title={"Volltextsuche nach Titel oder Gruppe "}
          />
          <Button
            label="&#127932; Titel"
            className={`md_title ${searchMode === SearchStates.title ? "active" : "inactive"}`}
            onClick={() => setSearchMode(SearchStates.title)}
            title={"Titel alphabetisch anzeigen"}
          />
          <Button
            label="&#127928; Gruppen"
            className={`md_group ${searchMode === SearchStates.group ? "active" : "inactive"}`}
            onClick={() => {setShowGroup(true); setSearchMode(SearchStates.group)}}
            title={"Gruppen alphabetisch"}
          />
          <Button
            label="&#128202; Charts"
            className={`md_charts ${searchMode === SearchStates.charts ? "active" : "inactive"}`}
            onClick={() => setSearchMode(SearchStates.charts)}
            title={"Charts listen anzeigen"}
          />
          <Button
            label="&#10024; Neu"
            className={"md_new active"}
            onClick={() => newTrack()}
            title={"Neuen Titel anlegen"}
          />
          <Button
            id="play"
            label="&#127911;"
            className={"md_play"}
            onClick={() => {
              setSearchMode(SearchStates.none);
              publicatePlayList(found ? [...app.tracks] : [...app.currentList]);
            }}
            disabled={false} // {!(showTrack?.audioSrc || app.tracks?.length > 0)}
            title={"Abspielen"}
          />
          {/* second line */}
          <div className="md_track_search">{renderTrackSearch()}</div>
        </div>
        <>
          {showTrack ? renderTrackGroupEdit(showTrack as ITitleLong) : renderTrackBox()}
        </>
        {confirm && renderListName() }
    </div>
  );
}
export default MediaDatabase;
